import { render, staticRenderFns } from "./sisSnackbarMessage.vue?vue&type=template&id=577eb15f"
import script from "./sisSnackbarMessage.vue?vue&type=script&lang=js"
export * from "./sisSnackbarMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports